import { useRequestParams } from '@hooks';
import { useQuery } from '@tanstack/react-query';
import { FormState, mutationKeys } from '@definitions';
import { getForms, GetFormsPayloadType, getLastDraftForms } from '@api';
import { FormApiType } from '@api/types';
import { useEffect } from 'react';
import { getStateKeyByValue } from '@utils';

import { formApiMapper } from '@/mappers';
import { ListForm } from '@/views/form';

const FormsPage = () => {
  const { afterPageChange, reqParams, setParams, pagination } = useRequestParams<
    GetFormsPayloadType,
    FormApiType
  >({
    initParams: {
      model: { state: [getStateKeyByValue(FormState, 'published')] },
    },
  });

  const { data: formDrafts = [] } = useQuery({
    queryKey: mutationKeys.draftForms(),
    queryFn: () => getLastDraftForms(),
    refetchOnWindowFocus: false,
    select: (formsApi) => formsApi?.map(formApiMapper),
  });

  const { data: forms = [], dataUpdatedAt } = useQuery({
    queryKey: mutationKeys.forms(reqParams),
    queryFn: () => getForms(reqParams),
    refetchOnWindowFocus: false,
    select: (formsApi) => formsApi?.map(formApiMapper),
  });

  useEffect(() => {
    afterPageChange(forms.length);
  }, [dataUpdatedAt]);

  return (
    <ListForm
      pagination={pagination}
      formDrafts={formDrafts}
      forms={forms}
      setParams={setParams}
      reqParams={reqParams}
    />
  );
};

export default FormsPage;
